import React, { Component, Fragment } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import { Col, Row } from "react-bootstrap";
import Form from "@common/externos/components/validation/form.validation";
import DDadosItem from "@common/components/ddados/ddados.item";
import { ddados } from "../emitir.ddados";
import Recapctcha from "react-recaptcha";
import autobind from "react-autobind";
import Card from "@common/externos/components/card/card.externo";
import emitirSelector from "../store/emitir.selectors";
import emitirActions from "../store/emitir.actions";

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  get initialValues() {
    return {};
  }

  //Funções de controle do ReCaptcha
  verifyCallback(response) {
    this.props.emitirActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.emitirActions.setTokenRecaptcha("");
  }

  //Form
  onSubmit(values) {
    this.props.emitirActions.save(values);
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "servicoEmpresa" });
  }

  render() {
    const { Campos } = ddados;
    return (
      <Card className={"pb-0"}>
        <h2 className={"mb-4"}>{ddados.Titulo}</h2>
        <Form
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        >
          {form => (
            <Fragment>
                <Row>
                  <Col xs={12} lg={4}>
                    <DDadosItem
                      name="InscricaoMunicipal"
                      {...Campos.InscricaoMunicipal}
                    />
                  </Col>
                  <Col xs={12} lg={4}>
                    <DDadosItem name="CpfCnpj" {...Campos.CpfCnpj} />
                  </Col>
                  <Col xs={12} lg={2}>
                    <DDadosItem name="Exercicio" {...Campos.Exercicio} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={4}>
                    <Recapctcha
                      sitekey={"6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh"}
                      verifyCallback={this.verifyCallback}
                      render={"explicit"}
                      expiredCallback={this.expiredCallback}
                      hl="pt-br"
                      theme="light"
                      size="normal"
                    />
                  </Col>
                </Row>
            </Fragment>
          )}
        </Form>
      </Card>
    );
  }
}

export default connect({
  actions: {
    emitirActions
  },
  selectors: {
    emitirSelector
  }
})(Container);
